import { AsyncPipe } from '@angular/common';
import { Component, DestroyRef, inject, input, OnDestroy, output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { PrivaNotificationModule } from '@priva/components/notification';
import { PrivaLocalizationModule } from '@priva/localization';

import { ScanButtonComponent } from 'app/features/scan-flow/components';
import { NfcReadEvent, ScannedCodeType } from 'app/features/scan-flow/models';

import { ScanNfcControllerStore } from './scan-nfc-controller.store';

const technicalProblemMessage = 'Unexpected technical problem';

@Component({
    selector: 'app-scan-nfc-controller',
    templateUrl: './scan-nfc-controller.component.html',
    styleUrl: './scan-nfc-controller.component.scss',
    imports: [PrivaNotificationModule, AsyncPipe, ScanButtonComponent, PrivaLocalizationModule],
    providers: [ScanNfcControllerStore],
})
export class ScanNfcControllerComponent implements OnDestroy {
    private destroyRef = inject(DestroyRef);
    readerMalfunction$ = this.componentStore.readerMalfunction$;
    readerMalfunctionMessage = technicalProblemMessage;

    hideReaderMalfunctionError = input(false);
    allowedCodeTypes = input(undefined, {
        transform: (value: ScannedCodeType[] | []) => {
            this.componentStore.setAllowedCodeTypes(value);
        },
    });
    showButton = input(true);

    readEvent = output<NfcReadEvent>();

    constructor(private componentStore: ScanNfcControllerStore) {
        this.componentStore.startReading();
        this.componentStore.readEvent$
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((readEvent) => this.readEvent.emit(readEvent));
    }

    ngOnDestroy(): void {
        this.componentStore.stopReading();
    }
}
